import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {getAll} from "app/requests/cases";
import {Loading} from "components/pages";
import {displayDateTime} from "lib/string";

function CasesList({getCases = getAll, prefix = ""}) {
  const [records, setRecords] = useState(null);

  useEffect(() => {
    getCases().then((data) => setRecords(data.cases));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-8 offset-lg-2">
          <h3 className="text-center">Cases</h3>
          <div className="row">
            {records.map((record) => (
              <div key={record.uid} className="col-md-6 offset-3">
                <a href={`${prefix}/cases/${record.uid}`}>
                  <h3 className="m-0 p-0">{record.title}</h3>
                </a>
                {record.categories.length > 0 && (
                  <div className="my-2">
                    {record.categories.map((tag) => (
                      <a key={tag} className="badge badge-pill badge-themed m-1" href={`/?search=${tag}`}>{tag}</a>
                    ))}
                  </div>
                )}
                <p>On {record.published_at ? displayDateTime(record.published_at) : "Unpublished"}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

CasesList.propTypes = {
  getCases: PropTypes.func,
  prefix: PropTypes.string
};

export default CasesList;
